function tryRemove(obj, list) {
    const i = list.indexOf(obj);
    if (i !== -1) {
        list.splice(i, 1);
    }
}

export { tryRemove };
//# sourceMappingURL=try-remove.js.map
